export const SECTION_ABOUT = "about"
export const SECTION_VIDEO_1 = "video-1"
export const SECTION_SCHEDULE = "schedule"
export const SECTION_SUBSCRIBE = "subscription"
export const SECTION_VIDEO_2 = "video-2"
export const SECTION_CURATORS = "curators"
export const SECTION_ROBOT = "robot"
export const SECTION_GALLERY = "gallery"
export const SECTION_ROUND_TABLE = "round-table"
export const SECTION_ASSOCIATIONS = "associations"

export const FACEBOOK_URL = "https://www.facebook.com/ornamikaproject/"
export const INSTAGRAM_URL = "https://www.instagram.com/ornamika_official/"
export const EMAIL = "mailto:hello@ornamika.ru"
export const ROUND_TABLE_URL = "https://ornamikalive.timepad.ru/event/1317928/"
export const BUY_PATTERN_URL = "https://example.com"
export const SURVEY_URL = "https://example.com"
export const ALI_EXPRESS_URL = "https://example.com"

export const COLORS = [
  {
    topBg: "plumPale",
    bodyBg: "plum",
  },
  {
    topBg: "tomatoPale",
    bodyBg: "tomato",
  },
  {
    topBg: "deepBluePale",
    bodyBg: "deepBlue",
  },
  {
    topBg: "plantPale",
    bodyBg: "plant",
  },
]
